import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import WhatsAppButton from "../src/components/WhatsAppButton";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <WhatsAppButton/>
    
  </>
);

reportWebVitals();
